/* eslint-disable */
const validate = (values) => {
  const errors = {};

  if (!values.select_project) {
    errors.select_project = 'Please select the option';
  }

  if (!values.select_year) {
    errors.select_year = 'Please select the option';
  }

  return errors;
};

export default validate;

